import React from 'react';
import { Avatar, makeStyles, Theme } from '@material-ui/core';
import { getUserAvatarInfo } from '@utils/getUserAvatar';

interface UserAvatarProps {
  userName: string;
  size?: number;
  padding?: number;
  onClick?: () => void;
}

const UserAvatar: React.FunctionComponent<UserAvatarProps> = ({
  userName,
  size,
  padding,
  onClick
}) => {
  const { avatarContainer, avatar } = useStyles({
    size,
    padding,
    hasAction: !!onClick
  });
  const { userColor, userInitial } = getUserAvatarInfo(userName);

  return (
    <div onClick={onClick} className={avatarContainer}>
      <Avatar className={avatar} style={{ backgroundColor: userColor }}>
        {userInitial}
      </Avatar>
    </div>
  );
};

export default UserAvatar;

const useStyles = makeStyles<
  Theme,
  { padding?: number; size?: number; hasAction: boolean }
>(() => ({
  avatarContainer: ({ size, padding, hasAction }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: size,
    height: size,
    padding,
    '&:hover': {
      cursor: hasAction ? 'cursor' : 'default'
    }
  }),
  avatar: {
    width: ({ size, padding = 0 }) => (size ? size - 2 * padding : undefined),
    height: ({ size, padding = 0 }) => (size ? size - 2 * padding : undefined)
  }
}));
